import React, { Suspense } from 'react'
import { SnackbarProvider } from 'notistack'
import { Route, Switch } from 'react-router-dom'
import { ReactComponent as SuccessSnackbarIcon } from 'core/assets/images/success-snackbar-icon.svg'
import useScrollToTop from 'core/common/hooks/useScrollToTop'
import CustomSnackbar from 'core/components/CustomSnackbar'
import LoadModules from 'core/components/LoadModules'
import AppLayout from 'core/containers/App/AppLayout'
import AppLoading from 'core/containers/App/AppLoading'
import AppSellerExists from 'core/containers/App/AppSellerExists'
import { SidebarMenu } from 'core/containers/App/AppShell'
import AppTheme from 'core/containers/App/AppTheme'
import { AppProvider } from 'core/pages/ProductNew-v2/context/AppContext'
import coreRoutes from 'core/routes'
import PRODUCT_NEW_STEPS_FLOW from './magaluConstants'
import channelRoutes from './routes'

import 'core/common/i18n'

const AppExport: React.FC = () => {
  const routes = [...coreRoutes, ...channelRoutes]

  useScrollToTop()

  return (
    <AppSellerExists>
      <AppProvider initialData={{ PRODUCT_NEW_STEPS_FLOW }}>
        <AppTheme>
          <SidebarMenu paddingTop={0} paddingLeftOnOpen={false}>
            <AppLayout custom={{ checkSellerMigration: true }}>
              <>
                <Suspense fallback={<AppLoading />}>
                  <SnackbarProvider
                    iconVariant={{
                      success: <SuccessSnackbarIcon className="mr-2" />,
                    }}
                    Components={{
                      success: CustomSnackbar,
                    }}
                  >
                    <Switch>
                      {routes.map(route => (
                        <Route
                          key={route.path}
                          path={route.path}
                          exact={route.exact}
                          component={route.component}
                        />
                      ))}
                    </Switch>
                    <LoadModules />
                  </SnackbarProvider>
                </Suspense>
              </>
            </AppLayout>
          </SidebarMenu>
        </AppTheme>
      </AppProvider>
    </AppSellerExists>
  )
}

export default AppExport
